import { DialogStyled } from "@/components/DialogStyled";
import { PlaylistGrid } from "@/components/PlaylistGrid";
import { Spinner } from "@/components/Spinner";
import {
  nextTrackState,
  playerPlaylistState,
  preferredViewModeState,
} from "@/context/states";
import { useSearchSongs } from "@/lib/api";
import theme from "@/styles/theme";
import { Grid, SvgIcon } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import SearchIcon from "ui/components/icons/SearchIcon";
import ModalSharePlaylist from "../ModalSharePlaylist";
import { MusicResultTableSong } from "../MusicResultTableSong";
import { SharePlaylistButton } from "../playlist/SharePlaylistButton";
import LoadMoreButton from "./LoadMoreButton";
import MusikSuchenResultsContainer from "./MusikSuchenResultsContainer";
import MusikSuchenResultsControlsContainer from "./MusikSuchenResultsControlsContainer";
import MusikSuchenResultsCount from "./MusikSuchenResultsCount";
import SwitchListGridButton from "./SwitchListGridButton";

export default function MusikSuchenResultSongs({
  searchConfig,
  urlPlaylist,
  playlist,
  onShareModelOpened,
  isModalOpen,
  onModalClosed,
}) {
  const [pageIndex, setPageIndex] = useState(0);
  const [result, setResults] = useState([]);
  const [playerPlaylist, setPlayerPlaylist] =
    useRecoilState(playerPlaylistState);
  const [nextTrack, setNextTrack] = useRecoilState(nextTrackState);
  const [activeSearch, setActiveSearch] = useState({});
  const preferredViewMode = useRecoilValue(preferredViewModeState);
  const { songs, isLoading, isValidating, isError } = useSearchSongs(
    activeSearch,
    pageIndex * 24,
    24,
  );

  const { songs: allSongs, isLoading: allLoading } = useSearchSongs(
    activeSearch,
    0,
    5000,
  );

  useEffect(() => {
    if (searchConfig) {
      //setResults([]);
      setActiveSearch(searchConfig);
      setPageIndex(0);
    }
  }, [searchConfig]);

  useEffect(() => {
    if (songs) {
      if (pageIndex === 0) {
        setResults(songs);
      } else {
        setResults([...result, ...songs]);
      }
    }
  }, [songs]);

  const handlePlaySong = (song) => {
    setPlayerPlaylist(allSongs);
    setNextTrack(song);
  };

  const handleModalClosed = () => {
    if (onModalClosed && typeof onModalClosed === "function") {
      onModalClosed();
    }
  };

  const handleShareModelOpened = () => {
    if (onShareModelOpened && typeof onShareModelOpened === "function") {
      onShareModelOpened();
    }
  };

  return (
    <MusikSuchenResultsContainer>
      <MusikSuchenResultsCount result={result} results={result.length} />
      <MusikSuchenResultsControlsContainer>
        <SharePlaylistButton onClick={handleShareModelOpened} />
        <DialogStyled
          open={isModalOpen}
          onClose={handleModalClosed}
          disableCloseOnBackgroundClick
        >
          <ModalSharePlaylist
            playlistType="filter"
            playlist={playlist}
            urlPlaylist={urlPlaylist}
            allowEditPlaylistName
          />
        </DialogStyled>
        <SwitchListGridButton />
      </MusikSuchenResultsControlsContainer>
      <Grid item xs={12}>
        <Grid container spacing={1} sx={{ position: "relative" }}>
          {isLoading ? (
            <Grid item xs={12} sx={loadingStyles}>
              <Spinner />
              <Typography
                className="caption"
                textAlign="center"
                variant="caption"
                component="p"
              >
                Ergebnisse werden gefiltert
              </Typography>
            </Grid>
          ) : (
            <>
              {result.length === 0 && (
                <Grid item xs={12}>
                  <Box sx={noResultsStyles}>
                    <SvgIcon>
                      <SearchIcon />
                    </SvgIcon>
                    <Typography textAlign="center" variant="body1">
                      Keine Ergebnisse gefunden
                    </Typography>
                  </Box>
                </Grid>
              )}
            </>
          )}
          <>
            {result.map((song, index) => (
              <>
                {preferredViewMode === "list" && (
                  <Grid item xs={12} key={index}>
                    <MusicResultTableSong
                      song={song}
                      onPlaySong={handlePlaySong}
                    />
                  </Grid>
                )}
                {preferredViewMode === "grid" && (
                  <Grid item xs={12} sm={6} key={index}>
                    <PlaylistGrid song={song} onPlaySong={handlePlaySong} />
                  </Grid>
                )}
              </>
            ))}
            {result.length % 24 === 0 && result.length !== 0 && (
              <Grid item xs={12}>
                <LoadMoreButton
                  pageIndex={pageIndex}
                  setPageIndex={setPageIndex}
                  label="Songs"
                />
              </Grid>
            )}
          </>
        </Grid>
      </Grid>
    </MusikSuchenResultsContainer>
  );
}

const loadingStyles = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  position: "absolute",
  zIndex: 40,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  "& .caption": {
    mt: "-1rem",
  },
};

const noResultsStyles = {
  textAlign: "center",
  padding: "2rem",
  backgroundColor: "#f4f4fe",
  "& .MuiTypography-root": {
    color: theme.palette.secondary.main,
  },
  "& .MuiSvgIcon-root": {
    fontSize: "5rem",
    color: "#d9d8fc",
  },
};
